import { render, staticRenderFns } from "./BindSubjectDialog.vue?vue&type=template&id=11a8637f&scoped=true"
import script from "./BindSubjectDialog.vue?vue&type=script&lang=js"
export * from "./BindSubjectDialog.vue?vue&type=script&lang=js"
import style0 from "./BindSubjectDialog.vue?vue&type=style&index=0&id=11a8637f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a8637f",
  null
  
)

export default component.exports